import React from 'react';

import {
  Dialog,
  DialogBody,
  DialogTitle,
} from '@/components/ui/catalyst/dialog';
import { FrontConversationResponse } from '@/services/api/frontMessageService';

import { FrontEmailThreadViewer } from './FrontEmailThreadViewer';

interface FrontEmailModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  matterId: string;
  /** Front conversation ID (cnv_xxx format) - use this OR conversationDbId */
  conversationId?: string;
  /** Database UUID for the conversation - use this OR conversationId */
  conversationDbId?: string;
  /** Message ID to highlight/scroll to */
  highlightMessageId?: string;
  /** Optional pre-loaded conversation data to avoid fetching */
  conversationData?: FrontConversationResponse | undefined;
}

export const FrontEmailModal: React.FC<FrontEmailModalProps> = ({
  isOpen,
  onOpenChange,
  matterId,
  conversationId,
  conversationDbId,
  highlightMessageId,
  conversationData,
}) => {
  return (
    <Dialog open={isOpen} onClose={onOpenChange} size="6xl" zIndex={60} nested>
      <DialogTitle>Email Thread</DialogTitle>
      <DialogBody className="h-[85vh] p-0 overflow-hidden">
        <FrontEmailThreadViewer
          matterId={matterId}
          conversationId={conversationId}
          conversationDbId={conversationDbId}
          highlightMessageId={highlightMessageId}
          conversationData={conversationData}
        />
      </DialogBody>
    </Dialog>
  );
};

export default FrontEmailModal;
